import { useTranslation } from "@redotech/redo-i18n";
import { FlowType } from "@redotech/redo-return-core-common/return-flow-enums";
import type { ProductTypeState } from "@redotech/redo-return-core-common/return-flow/condition-validate";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { RedoTagInputField } from "@redotech/redo-web/arbiter-components/input/redo-tag-input-field";
import { memo, useMemo, useState } from "react";

export const ProductTypeDetails = memo(function ProductTypeDetails({
  state,
  setState,
  disabled,
  flowType,
}: ConditionTypeDetailsProps<ProductTypeState>) {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState("");

  const tags = useMemo(
    () => state.map((tag) => ({ text: tag, color: "gray" as const })),
    [state],
  );

  const description =
    flowType === FlowType.FINALIZE_RETURN ||
    flowType === FlowType.FINALIZE_CLAIM
      ? t("Product types to search for in all selected items")
      : undefined;

  return (
    <RedoTagInputField
      delimiters={["newline"]}
      description={description}
      inputValue={inputValue}
      label={t("Product type")}
      placeholder={t("Type and press Enter to add")}
      setInputValue={setInputValue}
      setTags={setState}
      size="sm"
      state={disabled ? "disabled" : "default"}
      tags={tags}
    />
  );
});
